import { SurveyButton, SurveyItem, SurveyType } from '@r1-frontend/survey/context/surveys';

export interface SurveyItemWithType extends SurveyItem {
    type: SurveyType,
}

export type TShowDetails = {
    type: SurveyType | null,
    name?: string,
    inPopup?: boolean,
}

export interface SurveyInitialState {
    /**
     * Флаг подтверждающий пройденную инициализацию
     */
    _initialized: boolean,

    /**
     * Флаг состояния обработки запроса
     */
    _loading: boolean,

    _toShow: TShowDetails,

    survey: SurveyItemWithType[],

    /**
     * Данные для кнопки общего опроса
     */
    surveyButton?: SurveyButton,
}

export type SurveyIncomingData = Omit<SurveyInitialState, '_initialized' | '_loading'>

const initialState: SurveyInitialState = {
    _initialized: false,
    _loading: false,

    survey: [],

    _toShow: {
        type: null,
    },
};

export default initialState;
